const emailjsConfig = {
  serviceId:           process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId:          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  autoReplyTemplateId: process.env.REACT_APP_EMAILJS_AUTOREPLY_TEMPLATE_ID,
  publicKey:           process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
};

export default emailjsConfig;